import React from 'react';
import './login.style.sass';
import logo from '../../assets/image/icons/people.png';
import LoginFormComponent from "../../components/loginForm/loginForm.component";
import SignFormComponent from "../../components/signUpForm/signForm.component";
import {connect} from 'react-redux';
import {createStructuredSelector} from "reselect";
import {selectToggleSignForm} from "../../redux/site/site.selector";

const LoginLayout = () => {
    var x = false
    return (
        <div className='login-main'>
            <div className='blur'>
                <div className='login-content'>
                    <img src={logo} alt='xitonix' />
                    {
                        x ?
                        <LoginFormComponent />
                        : <SignFormComponent />

                    }
                    <div className='without-account'>
                        <p>حساب کاربری ندارید؟ <span>ثبت نام</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    FormStatus : selectToggleSignForm
})
// const mapDispatchToProps = dispatch => ({
//     ToggleForm : ()=> dispatch({type : SiteTypes.TOGGLE_SIGN_FORM})
// })

export default connect(mapStateToProps,)(LoginLayout);